import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { associations } from '../../../../../constants';
import { ControlGroup, ControlOption } from '../../../../components';

const AssociationFilter = ({
  changeHandler,
  show,
  selectedAssociations,
  selectAll,
  clearAll
}) => (
    <form id='association-filter' className={`slide-panel ${show === undefined ? 'hide' : ''} ${show ? 'in' : 'out'}`}>
      {
        false && <Row className='no-gutter'>
          <Col md={6} xs={12} className='right-padding-md bottom-padding-sm'>
            <Button onClick={selectAll} className='full'>Select All</Button>
          </Col>
          <Col md={6} xs={12} className='right-padding-md'>
            <Button onClick={clearAll} className='full'>Clear All</Button>
          </Col>
        </Row>
      }
      <Row className='no-gutter'>
        <ControlGroup
          control='checkbox'
          type='styled'
          label={null}
          colProps={{ xs: 12 }}>
          {
            fp.map(
              ({ value, label }) => (
                <ControlOption
                  key={value}
                  value={value}
                  checked={fp.includes(value)(selectedAssociations)}
                  onChange={(e) => changeHandler(e.target.value)}
                  label={<span>{label}</span>} />
              )
            )(associations)
          }
        </ControlGroup>
      </Row>
    </form>
  )

const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    selectAll: ({ setAll }) => () => {
      setAll(fp.map(
        ({ value }) => value
      )(associations))
    },
    clearAll: ({ setAll }) => () => {
      setAll([])
    }
  }),
)(AssociationFilter)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/association-filter.js